import dayjs from "dayjs";

export const MENSAJE_CANCELACION_MISMO_DIA =
  "Los turnos no pueden ser cancelados ni modificados el mismo día de la cita por este medio.\nComunicarse con Atención al Cliente al numero 3518-150-850";

export const esTurnoDelDia = (fecha) =>
  fecha != null &&
  fecha !== "" &&
  dayjs(fecha).isValid() &&
  dayjs(fecha).isSame(dayjs(), "day");
